import React from "react";
import "./ResultContent.css";

function ResultContent({ closestCharObj }) {
  return (
    <div className="ResultContent">
      <div className="resultContent-title">
        You look like {closestCharObj.name}!
      </div>
      <div className="resultContent-description">
        "{closestCharObj.description}"
      </div>
    </div>
  );
}

export default ResultContent;
